import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import keydown from 'react-keydown';
import onClickOutside from 'react-onclickoutside';
import _compact from 'lodash/compact';
import _get from 'lodash/get';
import Button from 'components/Button/Button';
import classes from './DialPad.module.scss';

const acceptedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '#', '*'];

export class DialPad extends React.Component {
  constructor(props) {
    super(props);
    this.state = { triggeredButton: null };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isVisible) {
      setTimeout(() => {
        //  Have to click on the element to be able to dial via keyboard.
        if (!this.dialContainer) return;
        this.dialContainer.click();
      }, 500);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  }

  onKeyDown = (event) => {
    if (!this.props.isVisible) return;
    if (acceptedKeys.indexOf(event.key) !== -1) {
      this.props.addNumber(event.key);
      this.setState({ triggeredButton: event.key });
    }
  };

  onKeyUp = () => {
    if (!this.props.isVisible) return;
    if (this.state.triggeredButton) {
      this.setState({ triggeredButton: null });
    }
  };

  getButtonClass = (number) =>
    _compact([classes.numberContainer, number === this.state.triggeredButton ? classes.triggeredKey : '']).join(' ');

  handleClickOutside(evt) {
    if (!_get(evt, 'target.className')) return;
    if (
      evt.target.className &&
      typeof evt.target.className.indexOf === 'function' &&
      evt.target.className.indexOf('numberContainer') === -1 &&
      evt.target.className.indexOf('dialPadContainer') === -1 &&
      this.props.isVisible
    ) {
      this.props.handleClose();
    }
  }

  render() {
    if (!this.props.isVisible) return <div style={{ display: 'none' }} />;
    return (
      <div
        tabIndex="0"
        className={classes.dialPadContainer}
        ref={(comp) => {
          this.dialContainer = comp;
        }}
      >
        <div className={classes.buttonContainer}>
          <div>
            <button className={this.getButtonClass('1')} onClick={() => this.props.addNumber('1')}>
              1
            </button>
            <button className={this.getButtonClass('2')} onClick={() => this.props.addNumber('2')}>
              2
            </button>
            <button className={this.getButtonClass('3')} onClick={() => this.props.addNumber('3')}>
              3
            </button>
          </div>

          <div>
            <button className={this.getButtonClass('4')} onClick={() => this.props.addNumber('4')}>
              4
            </button>
            <button className={this.getButtonClass('5')} onClick={() => this.props.addNumber('5')}>
              5
            </button>
            <button className={this.getButtonClass('6')} onClick={() => this.props.addNumber('6')}>
              6
            </button>
          </div>

          <div>
            <button className={this.getButtonClass('7')} onClick={() => this.props.addNumber('7')}>
              7
            </button>
            <button className={this.getButtonClass('8')} onClick={() => this.props.addNumber('8')}>
              8
            </button>
            <button className={this.getButtonClass('9')} onClick={() => this.props.addNumber('9')}>
              9
            </button>
          </div>

          <div>
            <button className={this.getButtonClass('#')} onClick={() => this.props.addNumber('#')}>
              #
            </button>
            <button className={this.getButtonClass('0')} onClick={() => this.props.addNumber('0')}>
              0
            </button>
            <button className={this.getButtonClass('*')} onClick={() => this.props.addNumber('*')}>
              *
            </button>
          </div>
        </div>

        <div className={classes.closeContainer}>
          <Button kind={'primary'} onClick={() => this.props.handleClose()} size={'small'}>
            <FormattedMessage id="dialPad.button.label" defaultMessage="Close" />
          </Button>
        </div>
      </div>
    );
  }
}

DialPad.propTypes = {
  isVisible: PT.bool.isRequired,
  handleClose: PT.func.isRequired,
  addNumber: PT.func.isRequired
};

export default keydown(onClickOutside(DialPad));
